import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

interface MonthSelectProps {
  date: Date;
  minDate: Date;
  maxDate: Date;
  disabled?: boolean;
  setDate: (date: Date) => void;
}

export const MonthSelect = ({
  date,
  minDate,
  maxDate,
  disabled,
  setDate,
}: MonthSelectProps) => {
  return (
    <DatePicker
      disabled={disabled}
      label={"Reporting Month"}
      openTo="month"
      views={["year", "month"]}
      format="DD-MM-YYYY"
      value={dayjs(date)}
      minDate={dayjs(minDate)}
      maxDate={dayjs(maxDate)}
      onChange={(newValue) => {
        if (newValue) {
          setDate(newValue?.toDate());
        }
      }}
      slotProps={{
        textField: {
          size: "small",
          error: false,
          margin: "dense",
        },
      }}
    />
  );
};
